/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceDTO
 */
export interface InvoiceDTO {
    /**
     * 
     * @type {string}
     * @memberof InvoiceDTO
     */
    invoice: string;
}

/**
 * Check if a given object implements the InvoiceDTO interface.
 */
export function instanceOfInvoiceDTO(value: object): value is InvoiceDTO {
    if (!('invoice' in value) || value['invoice'] === undefined) return false;
    return true;
}

export function InvoiceDTOFromJSON(json: any): InvoiceDTO {
    return InvoiceDTOFromJSONTyped(json, false);
}

export function InvoiceDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice': json['invoice'],
    };
}

export function InvoiceDTOToJSON(value?: InvoiceDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'invoice': value['invoice'],
    };
}

